import Vconsole from 'vconsole';
if (import.meta.env.VITE_APP_MODE === 'test' || import.meta.env.VITE_APP_MODE === 'development') {
  new Vconsole();
}
let isTrigger = false; // 只触发一次打开vconsole
/**
 * 触发打开Vconsole
 * @description 根据外部配置文件判断是否开启vconsole，是则打开
 */
export const triggerOpenVconsole = (uid: number) => {
  if (import.meta.env.VITE_APP_MODE === 'production') {
    if (isTrigger) return;
    isTrigger = true;
    const auth = window.whiteList?.includes(uid);
    if (auth) {
      new Vconsole();
    }
  }
};
